import globals from '../../globals';
import { _sendWithAxios } from '../api'

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API;

export const efetuarLogin = async (data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Autenticacao/login`, 'POST', data);
}
